"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.patchConsensusErrors = void 0;
function patchConsensusErrors() {
    // TODO(versioning): restore this
    // extend(dpp_module.ProtocolVersionParsingError, AbstractConsensusError);
    // extend(dpp_module.UnsupportedProtocolVersionError, AbstractConsensusError);
    // extend(dpp_module.IncompatibleProtocolVersionError, AbstractConsensusError);
    // extend(dpp_module.SerializedObjectParsingError, AbstractConsensusError);
    // extend(dpp_module.JsonSchemaError, AbstractConsensusError);
    // extend(dpp_module.InvalidIdentifierError, AbstractConsensusError);
    // extend(dpp_module.DataContractMaxDepthExceedError, AbstractConsensusError);
    // extend(dpp_module.DuplicateIndexError, AbstractConsensusError);
    // extend(dpp_module.InvalidCompoundIndexError, AbstractConsensusError);
    // extend(dpp_module.InvalidDataContractIdError, AbstractConsensusError);
    // extend(dpp_module.InvalidIndexedPropertyConstraintError, AbstractConsensusError);
    // extend(dpp_module.InvalidIndexPropertyTypeError, AbstractConsensusError);
    // extend(dpp_module.SystemPropertyIndexAlreadyPresentError, AbstractConsensusError);
    // extend(dpp_module.UndefinedIndexPropertyError, AbstractConsensusError);
    // extend(dpp_module.UniqueIndicesLimitReachedError, AbstractConsensusError);
    // extend(dpp_module.InconsistentCompoundIndexDataError, AbstractConsensusError);
    // extend(dpp_module.InvalidDocumentTransitionActionError, AbstractConsensusError);
    // extend(dpp_module.InvalidDocumentTransitionIdError, AbstractConsensusError);
    // extend(dpp_module.DataContractNotPresentError, AbstractConsensusError);
    // extend(dpp_module.InvalidDocumentTypeError, AbstractConsensusError);
    // extend(dpp_module.MissingDataContractIdError, AbstractConsensusError);
    // extend(dpp_module.MissingDocumentTransitionActionError, AbstractConsensusError);
    // extend(dpp_module.MissingDocumentTransitionTypeError, AbstractConsensusError);
    // extend(dpp_module.MissingDocumentTypeError, AbstractConsensusError);
    // extend(dpp_module.DuplicatedIdentityPublicKeyError, AbstractConsensusError);
    // extend(dpp_module.DuplicatedIdentityPublicKeyIdError, AbstractConsensusError);
    // extend(dpp_module.MissingMasterPublicKeyError, AbstractConsensusError);
    // extend(dpp_module.IdentityAssetLockProofLockedTransactionMismatchError, AbstractConsensusError);
    // extend(dpp_module.IdentityAssetLockTransactionIsNotFoundError, AbstractConsensusError);
    // extend(dpp_module.IdentityAssetLockTransactionOutPointAlreadyExistsError, AbstractConsensusError);
    // extend(dpp_module.IdentityAssetLockTransactionOutputNotFoundError, AbstractConsensusError);
    // extend(dpp_module.InvalidAssetLockProofCoreChainHeightError, AbstractConsensusError);
    // extend(dpp_module.InvalidAssetLockProofTransactionHeightError, AbstractConsensusError);
    // extend(dpp_module.InvalidIdentityAssetLockTransactionError, AbstractConsensusError);
    // extend(dpp_module.InvalidIdentityAssetLockTransactionOutputError, AbstractConsensusError);
    // extend(dpp_module.InvalidIdentityPublicKeyDataError, AbstractConsensusError);
    // extend(dpp_module.InvalidIdentityPublicKeySecurityLevelError, AbstractConsensusError);
    // extend(dpp_module.InvalidStateTransitionTypeError, AbstractConsensusError);
    // extend(dpp_module.MissingStateTransitionTypeError, AbstractConsensusError);
    // extend(dpp_module.StateTransitionMaxSizeExceededError, AbstractConsensusError);
    // extend(dpp_module.IdentityNotFoundError, AbstractConsensusError);
    // extend(dpp_module.InvalidIdentityPublicKeyTypeError, AbstractConsensusError);
    // extend(dpp_module.InvalidStateTransitionSignatureError, AbstractConsensusError);
    // extend(dpp_module.MissingPublicKeyError, AbstractConsensusError);
    // extend(dpp_module.BalanceIsNotEnoughError, AbstractConsensusError);
    // extend(dpp_module.DataContractAlreadyPresentError, AbstractConsensusError);
    // extend(dpp_module.DataTriggerConditionError, AbstractConsensusError);
    // extend(dpp_module.DataTriggerExecutionError, AbstractConsensusError);
    // extend(dpp_module.DataTriggerInvalidResultError, AbstractConsensusError);
    // extend(dpp_module.DocumentAlreadyPresentError, AbstractConsensusError);
    // extend(dpp_module.DocumentNotFoundError, AbstractConsensusError);
    // extend(dpp_module.DocumentOwnerIdMismatchError, AbstractConsensusError);
    // extend(dpp_module.DocumentTimestampsMismatchError, AbstractConsensusError);
    // extend(dpp_module.DocumentTimestampWindowViolationError, AbstractConsensusError);
    // extend(dpp_module.DuplicateUniqueIndexError, AbstractConsensusError);
    // extend(dpp_module.InvalidDocumentRevisionError, AbstractConsensusError);
    // extend(dpp_module.IdentityAlreadyExistsError, AbstractConsensusError);
    // extend(dpp_module.InvalidJsonSchemaRefError, AbstractConsensusError);
    // extend(dpp_module.JsonSchemaCompilationError, AbstractConsensusError);
    // extend(dpp_module.DuplicateDocumentTransitionsWithIdsError, AbstractConsensusError);
    // extend(dpp_module.DuplicateDocumentTransitionsWithIndicesError, AbstractConsensusError);
    // extend(dpp_module.InvalidAssetLockTransactionOutputReturnSizeError, AbstractConsensusError);
    // extend(dpp_module.InvalidInstantAssetLockProofError, AbstractConsensusError);
    // extend(dpp_module.InvalidInstantAssetLockProofSignatureError, AbstractConsensusError);
    // extend(dpp_module.IncompatibleRe2PatternError, AbstractConsensusError);
    // extend(dpp_module.InvalidDataContractVersionError, AbstractConsensusError);
    // extend(dpp_module.IncompatibleDataContractSchemaError, AbstractConsensusError);
    // extend(dpp_module.DataContractImmutablePropertiesUpdateError, AbstractConsensusError);
    // extend(dpp_module.DataContractUniqueIndicesChangedError, AbstractConsensusError);
    // extend(dpp_module.DuplicateIndexNameError, AbstractConsensusError);
    // extend(dpp_module.DataContractInvalidIndexDefinitionUpdateError, AbstractConsensusError);
    // extend(dpp_module.DataContractHaveNewUniqueIndexError, AbstractConsensusError);
    // extend(dpp_module.IdentityPublicKeyDisabledAtWindowViolationError, AbstractConsensusError);
    // extend(dpp_module.IdentityPublicKeyIsReadOnlyError, AbstractConsensusError);
    // extend(dpp_module.InvalidIdentityPublicKeyIdError, AbstractConsensusError);
    // extend(dpp_module.InvalidIdentityRevisionError, AbstractConsensusError);
    // extend(dpp_module.MaxIdentityPublicKeyLimitReachedError, AbstractConsensusError);
    // extend(dpp_module.InvalidIdentityKeySignatureError, AbstractConsensusError);
    // extend(dpp_module.InvalidSignaturePublicKeySecurityLevelError, AbstractConsensusError);
    // extend(dpp_module.PublicKeyIsDisabledError, AbstractConsensusError);
    // extend(dpp_module.PublicKeySecurityLevelNotMetError, AbstractConsensusError);
    // extend(dpp_module.WrongPublicKeyPurposeError, AbstractConsensusError);
    // extend(dpp_module.IdentityPublicKeyIsDisabledError, AbstractConsensusError);
    // extend(dpp_module.ValueError, AbstractConsensusError);
    // extend(dpp_module.MissingDataContractIdError, AbstractConsensusError);
    // extend(dpp_module.DuplicatedIdentityPublicKeyError, AbstractConsensusError);
    // extend(dpp_module.DuplicatedIdentityPublicKeyIdError, AbstractConsensusError);
    // extend(dpp_module.IdentityInsufficientBalanceError, AbstractConsensusError);
    // extend(dpp_module.InvalidCreditWithdrawalTransitionCoreFeeError, AbstractConsensusError);
    // extend(dpp_module.InvalidCreditWithdrawalTransitionOutputScriptError, AbstractConsensusError);
    // extend(dpp_module.NotImplementedCreditWithdrawalTransitionPoolingError, AbstractConsensusError);
    // extend(dpp_module.DuplicatedIdentityPublicKeyIdStateError, AbstractConsensusError);
    // extend(dpp_module.DuplicatedIdentityPublicKeyStateError, AbstractConsensusError);
}
exports.patchConsensusErrors = patchConsensusErrors;
